module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-stone-path.1c8bf86f.png";